<div [formGroup]="form" [id]="fieldName" class="flex flex-col grow">
  @if (fieldName) {
    <div class="self-start w-full">
      <p-float-label [variant]="labelVariant" [class.mt-0]="labelVariant === 'in'">
        <p-inputgroup class="flex">
          @if (prefix) {
            <ng-template [ngTemplateOutlet]="prefix"></ng-template>
          }
          @if (mask) {
            <p-inputmask
              #elementRef
              class="flex w-full"
              styleClass="w-full"
              [id]="'input-' + fieldName + groupName"
              [inputId]="'input-' + fieldName + groupName"
              [s-blur]="attribute?.dataClassification"
              [required]="isRequired()"
              [type]="type ?? 'text'"
              [readonly]="readonly"
              [formControlName]="fieldName"
              [autocomplete]="autocomplete"
              [mask]="mask"
              (focus)="onFocus($event)"
              (blur)="onBlur($event)"
              unmask="true"
            />
          } @else {
            <input
              pInputText
              #elementRef
              [id]="'input-' + fieldName + groupName"
              [s-blur]="attribute?.dataClassification"
              [required]="isRequired()"
              [type]="type ?? 'text'"
              [readonly]="readonly"
              [formControlName]="fieldName"
              [autocomplete]="autocomplete"
              (focus)="onFocus($event)"
              (blur)="onBlur($event)"
              [fluid]="true"
              [pSize]="size == 'large' ? 'large' : size == 'small' ? 'small' : undefined"
            />
          }
          @if (suffix) {
            <ng-template [ngTemplateOutlet]="suffix"></ng-template>
          }
          @if (label) {
            <label [for]="'input-' + fieldName + groupName" class="z-10"
              >{{ label }}
              @if (attribute?.displayNameSuffixIcon) {
                <i inline style="font-size: small">{{ attribute?.displayNameSuffixIcon }}</i>
              }
              @if (isRequired()) {
                <span style="color: red">*</span>
              }
            </label>
          }
        </p-inputgroup>
      </p-float-label>
      <ng-content></ng-content>
      @if (displayHint || attribute?.displayHint) {
        <small class="block">
          {{ displayHint ? displayHint : attribute?.displayHint }}
        </small>
      }
      <s-form-error-input
        [groupName]="groupName"
        [fieldName]="fieldName"
        [form]="form"
        [apiError]="apiError"
        [schema]="schema"
      />
    </div>
  }
</div>
